var map = {
	"./__variants__/plp-guided-search/single/CategoryPage.js": 79911,
	"./__variants__/plp-guided-search/text/CategoryPage.js": 19506,
	"./__variants__/plp-guided-search/tile/CategoryPage.js": 96611,
	"./__variants__/plp-visual-categories/v2/CategoryPage.js": 17745
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 56524;